import * as React from "react";

const ACTIVITY_EVENTS = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"] as const;

interface UseIdleTimerOptions {
  idleMs: number;
  onIdle: () => void;
  enabled?: boolean;
}

/** Fires onIdle once the user has produced no input activity for idleMs. */
export function useIdleTimer({ idleMs, onIdle, enabled = true }: UseIdleTimerOptions) {
  const timeoutRef = React.useRef<number | undefined>(undefined);
  const onIdleRef = React.useRef(onIdle);
  onIdleRef.current = onIdle;

  const reset = React.useCallback(() => {
    if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => onIdleRef.current(), idleMs);
  }, [idleMs]);

  React.useEffect(() => {
    if (!enabled) return;
    reset();
    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, reset, { passive: true }));
    return () => {
      if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
    };
  }, [enabled, reset]);

  return { reset };
}
